import { BACKUP_FORMAT } from "./schema";
import type { DetectedFormat } from "./types";

/**
 * Detecção de formato de arquivo de backup, sem escrever nada.
 */
export function detectFormat(raw: unknown): DetectedFormat {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return "unknown";
  const obj = raw as Record<string, any>;
  if (obj.format === BACKUP_FORMAT && typeof obj.formatVersion === "number") return "clinicalos";
  if (obj.piruExportVersion !== undefined && Array.isArray(obj.sessions)) return "piru";
  if (typeof obj.schema_version === "number" && obj.tables && typeof obj.tables === "object") return "legacy";
  return "unknown";
}

export function formatLabel(format: DetectedFormat): string {
  switch (format) {
    case "clinicalos":
      return "ClinicalOS v1";
    case "piru":
      return "Piru v1";
    case "legacy":
      return "Backup antigo ClinicalOS";
    default:
      return "Formato não reconhecido";
  }
}

/** epoch ms (ou ISO) -> ISO 8601. Retorna null quando não é convertível. */
export function toIsoTimestamp(value: unknown): string | null {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number") {
    const ms = value < 1e12 ? value * 1000 : value;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
  }
  if (typeof value === "string") {
    const numeric = Number(value);
    if (/^\d+$/.test(value.trim()) && Number.isFinite(numeric)) return toIsoTimestamp(numeric);
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
  }
  return null;
}
